<template>
  <div
    :key="$route.params.song"
    class="section pt-0"
  >
    <div class="container">
      <h1 class="title">
        {{ song.title }} ({{ song.year }})
      </h1>

      <div class="columns">
        <div
          v-if="authors.length > 0"
          class="column"
        >
          <h2 class="subtitle mb-5">
            Auteurs
          </h2>
          <div class="tags">
            <span
              v-for="artist in authors"
              :key="artist.id"
              class="tag"
            >
              <a
                role="button"
                @click="toArtist(artist)"
              >{{ artist.name }} ({{ artist.country_birth }})</a>
            </span>
          </div>
        </div>
        <div
          v-if="composers.length > 0"
          class="column"
        >
          <h2 class="subtitle mb-5">
            Compositeurs
          </h2>
          <div class="tags">
            <span
              v-for="artist in composers"
              :key="artist.id"
              class="tag"
            >
              <a
                role="button"
                @click="toArtist(artist)"
              >{{ artist.name }} ({{ artist.country_birth }})</a>
            </span>
          </div>
        </div>
        <div
          v-if="interprets.length > 0"
          class="column"
        >
          <h2 class="subtitle mb-5">
            Interprètes
          </h2>
          <div class="tags">
            <span
              v-for="artist in interprets"
              :key="artist.id"
              class="tag"
            >
              <a
                role="button"
                @click="toArtist(artist)"
              >{{ artist.name }} ({{ artist.country_birth }})</a>
            </span>
          </div>
        </div>
        <div
          v-if="covers.length > 0"
          class="column"
        >
          <h2 class="subtitle mb-5">
            Reprises
          </h2>
          <div class="tags">
            <span
              v-for="artist in covers"
              :key="artist.id"
              class="tag"
            >
              <a
                role="button"
                @click="toArtist(artist)"
              >{{ artist.name }} ({{ artist.country_birth }})</a>
            </span>
          </div>
        </div>
      </div>

      <b-tabs
        v-model="activeTab"
        position="is-centered"
        class="block"
        type="is-boxed"
        @change="changeTab"
      >
        <b-tab-item label="Arbre d'inspiration">
          <h2 class="title is-4">
            Arbre d'inspiration
          </h2>
          <v-tree :song="song" />
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Tree from "@/components/tree2/Tree.vue";
import { toArtist } from "@/services/navigator";

let sections = [
	"arbre"
];

export default {
	components: {
		"v-tree": Tree,
	},
	data () {
		return {
			activeTab: (this.$route.params.section) ? sections.indexOf(this.$route.params.section) : 0
		};
	},
	computed: {
		song () {
			return this.$store.state.songs[this.$route.params.song];
		},
		authors () {
			return this.song.author_ids.map(id => {
				return this.$store.state.artists[id];
			});
		},
		composers () {
			return this.song.composer_ids.map(id => {
				return this.$store.state.artists[id];
			});
		},
		interprets () {
			return this.song.interpret_ids.map(id => {
				return this.$store.state.artists[id];
			});
		},
		covers () {
			return this.song.cover_ids.map(id => {
				return this.$store.state.artists[id];
			});
		}
	},
	methods: {
		toArtist (artist) {
			toArtist(artist.id);
		},
		changeTab (index) {
			this.$router.push({ name: "song", params: {song: this.$route.params.song, section: sections[index]} });
		}
	}
};
</script>
